<script lang="ts">
    import { location, news, persons } from "./lib/store"
    import SsrSkip from "./lib/components/SsrSkip.svelte"
    import Header from "./lib/components/Header.svelte"
    import Footer from "./lib/components/Footer.svelte"
    import Content from "./lib/components/Content.svelte"
    import Preview from "./routes/Preview.svelte"
    import { getDBEntries } from "./api"
    import Sidebar from "./lib/components/sidebar.svelte"

    export let url = ""

    if (url) {
        // ssr
        let l = url.split("?")
        $location = {
            path: l[0],
            search: l.length > 1 ? l[1] : "",
            hash: "",
            push: false,
            pop: false,
        }
    }
    getDBEntries("team").then((data) => {
        data.forEach((person) => {
            $persons[person.id] = person
        })
    })
</script>

<Header />
{#if $location?.path?.startsWith("/preview")}
    <Preview />
{:else}
    <Content location="{$location}" />
{/if}
<Footer />
<Sidebar />
<SsrSkip />

<style lang="less" global>
    @import "./css/base.less";

    /* gudea-regular - latin */
    @font-face {
        font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
        font-family: "Gudea";
        font-style: normal;
        font-weight: 400;
        src: url("../assets/fonts/gudea-v15-latin-regular.woff2") format("woff2"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
    }
    /* gudea-italic - latin */
    @font-face {
        font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
        font-family: "Gudea";
        font-style: italic;
        font-weight: 400;
        src: url("../assets/fonts/gudea-v15-latin-italic.woff2") format("woff2"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
    }
    /* gudea-700 - latin */
    @font-face {
        font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
        font-family: "Gudea";
        font-style: normal;
        font-weight: 700;
        src: url("../assets/fonts/gudea-v15-latin-700.woff2") format("woff2"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
    }

    html {
        font-size: 20px;
        @media @mobile {
            font-size: 18px;
        }
    }
    body {
        margin: 0px;
        height: 100%;
        font-family: "Gudea", sans-serif;
        font-style: normal;
        width: 100%;
        font-size: 0.9rem;

        main {
            width: 100%;
        }
    }
</style>
